import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { QueryClient } from '@tanstack/angular-query-experimental';
import { SESSION_EXPIRED_HTTP_STATUS } from '@core/interceptors/base-http-inteceptor';

/** Riconosce l'errore sintetico con cui l'interceptor fa fallire le richieste mentre la sessione risulta scaduta. */
const isSessionExpiredError = (error: unknown): boolean => {
  if (!(error instanceof HttpErrorResponse)) {
    return false;
  }
  return error.status === SESSION_EXPIRED_HTTP_STATUS;
};

/**
 * Invalida le sole query in errore per sessione scaduta, e lascia dov'è il dato ancora buono.
 *
 * Con i retry disattivati quelle query restano in errore anche dopo che la sessione è tornata valida:
 * questa rilettura le rimette in esecuzione, e non tocca quelle che non ancora contengono il dato.
 *
 * L'invalidazione resta locale a questa scheda del browser e non viene propagata alle altre. Quali query
 * siano in errore dipende da che cosa questa scheda stava chiedendo mentre era senza token, e in un'altra
 * scheda le stesse chiavi possono portare un dato valido.
 *
 * @returns Funzione che invalida le query in errore e attende la loro rilettura.
 */
export const injectInvalidateFailedQueries = () => {
  const queryClient = inject(QueryClient);
  return (): Promise<void> => {
    return queryClient.invalidateQueries({
      predicate: (query) => isSessionExpiredError(query.state.error)
    });
  };
};
